export const i18nTypes = {
  I18nService: Symbol.for('I18nService'),
  I18nCurrentLocale: Symbol.for('I18nCurrentLocale'),
}
